export const soldProductsV2 = {
	tabTitle: "Productos Vendidos",
	header: {
		title: "Productos Vendidos",
		subtitle:
			"Acompañe los productos vendidos y visualice sus ventas de forma detallada.",
		exportButton: "Exportar",
		exportLoading: "Exportando...",
		exportNotification:
			"el informe será generado y una vez listo será enviado a su correo electrónico ({{email}})",
	},
	inlineFilters: {
		filterByProduct: "Filtrar por producto",
		noProductFound: "Ningún producto encontrado",
		filterByCategory: "Filtrar por categoría del producto",
		noCategoryFound: "Ninguna categoría encontrada",
		filtersButton: "Filtros",
		groupByProduct: "Agrupado por Producto",
		groupByBar: "Agrupado por Barra",
	},
	filterModal: {
		title: "Filtros",
		filterOptionsLabel: "Opciones de filtros",
		filteredBy: "Filtrado por",
		clearSelection: "Limpiar selección",
		cancel: "Cancelar",
		clearFilters: "Limpiar filtros",
		apply: "Aplicar",
		nav: {
			dateOrPeriod: "Fecha o período",
			product: "Producto",
			barsAndSectors: "Barras y sectores",
			operation: "Operación",
			transactions: "Transacciones",
		},
		period: {
			today: "Hoy",
			yesterday: "Ayer",
			last30Days: "Últimos 30 días",
			customPeriod: "Período personalizado",
		},
		periodLabels: {
			today: "hoy",
			yesterday: "ayer",
			last_30_days: "últimos 30 días",
			custom: "período personalizado",
		},
		productSection: {
			productLabel: "Producto",
			productStatusLabel: "Estado del producto",
			productTypeLabel: "Tipo de producto",
			categoryLabel: "Categoría",
			filterByProduct: "Filtrar por producto",
			filterByType: "Filtrar por tipo",
			filterByCategory: "Filtrar por categoría",
			noProductFound: "Ningún producto encontrado",
			noTypeFound: "Ningún tipo encontrado",
			noCategoryFound: "Ninguna categoría encontrada",
		},
		status: {
			active: "Activo",
			inactive: "Inactivo",
			unavailable: "Indisponible",
		},
		barsAndSectorsSection: {
			barLabel: "Barra",
			sectorLabel: "Sector",
			filterByBar: "Filtrar por barra",
			filterBySector: "Filtrar por sector",
			noBarFound: "Ninguna barra encontrada",
			noSectorFound: "Ningún sector encontrado",
		},
		operationSection: {
			operationTypeLabel: "Tipo de operación",
		},
		operationTypes: {
			Table: "Operación mesa",
			ZigTag: "Operación cashless",
		},
		transactionsSection: {
			transactionTypeLabel: "Tipo de transacción",
			filterByTransaction: "Filtrar por transacción",
			noTypeFound: "Ningún tipo encontrado",
		},
		sources: {
			balcony: "Barra",
			cashless: "Cashless",
			dash: "Dashboard",
			delivery: "Delivery",
			ficha: "Ficha",
			grabngo: "Grab n Go",
			onlineBill: "Comanda Online",
			zigQrcode: "QR Code Zig",
			onlineFicha: "Ficha Digital",
			table: "Mesa",
			hce: "Tarjeta digital",
		},
		activeFilterLabels: {
			period: "PERÍODO",
			status: "ESTADO",
			operation: "OPERACIÓN",
			product: "PRODUCTO",
			category: "CATEGORÍA",
			bar: "BARRA",
			sector: "SECTOR",
			transaction: "TRANSACCIÓN",
		},
	},
	table: {
		sku: "SKU",
		name: "Nombre",
		status: "Estado",
		statusLabels: {
			active: "Activo",
			inactive: "Inactivo",
			unavailable: "Indisponible",
		},
		unitQty: "Cant. Unit.",
		unitValue: "Valor Unit.",
		subtotal: "SUBTOTAL",
		discounts: "Descuentos",
		totalValue: "VALOR TOTAL",
		subtotalTooltip: "Valor total sin contabilizar los descuentos.",
		totalValueTooltip: "Valor total con los descuentos aplicados.",
		mountable: "(armable)",
		devolution: "Devolución",
		total: "Total",
		values: "{{count}} valores",
		noBar: "Sin barra",
		variationUnitQty: "Cant Unit",
		variationUnitValue: "Valor Unit",
		variationSubtotal: "Subtotal",
		variationDiscounts: "Descuentos",
		variationTotalValue: "Valor Total",
	},
	mountableModal: {
		name: "Nombre",
		section: "Sección",
		quantity: "Cantidad",
	},
};
